<template>
  <div data-qa="patient_profile_rates_statistic">
    <div class="d-flex justify-space-between text-subtitle-1 mb-4">
      <span class="mr-4">
        {{ t('Отзывы', options) }}
      </span>
      {{ countAll }}
    </div>
    <v-progress-linear
      v-if="countAccurate"
      class="mb-4"
      height="8"
      rounded
      :value="valueProgressReviews"
      color="success"
      background-color="error"
    />
    <div
      v-if="countPositive"
      class="d-flex justify-space-between mb-2"
    >
      <span class="text-body-1 text-secondary--text mr-4">
        {{ t('Положительные', options) }}
      </span>
      <span class="amount-icon text-body-2 rounded bg-success success--text ">
        {{ countPositive }}
      </span>
    </div>
    <div
      v-if="countNegative"
      class="d-flex justify-space-between mb-2"
    >
      <span class="text-body-1 text-secondary--text mr-4">
        {{ t('Отрицательные', options) }}
      </span>
      <span class="amount-icon text-body-2 rounded bg-error error--text">
        {{ countNegative }}
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import getUserLanguage from 'src/utils/getUserLanguage'
import I18NextVue from 'i18next'

const props = defineProps<{
  countCanceled: number
  countPositive: number
  countNegative: number
  countWithoutMark: number
}>()

const options = { ns: getUserLanguage() }
const { t } = I18NextVue

const countAccurate = computed(() => (props.countPositive + props.countNegative))
const countAll = computed(() => (countAccurate.value + props.countCanceled + props.countWithoutMark))
const valueProgressReviews = computed(() => ((props.countPositive * 100) / countAccurate.value))
</script>

<style lang="scss" scoped>
.amount-icon {
  line-height: normal;
  padding: 4px 6px;
}
</style>
